import { watchPreviewWithShopify } from 'store/global/socket/syncShopifyNClonePageAtomServiceToThemeAtomService/watchPreviewWithShopify';
import { watchSyncToShopify } from 'store/global/socket/syncShopifyNClonePageAtomServiceToThemeAtomService/watchSyncToShopify';

export const sagasSocket = [watchSyncToShopify, watchPreviewWithShopify];
